export default __webpack_public_path__ + "static/img-ef-12-75b1e4babb73bb9fa6e4ae5b54599753.png";